import React from "react";
import Banner from "../../components/main/Banner";
import StepUp from "../../components/main/StepUp";
// import Jobs from "../../components/main/Jobs";
// import Courses from "../../components/main/Courses";
import HelpBid from "../../components/main/HelpBid";
import TopSkills from "../../components/main/TopSkills";

function LandingPage() {
  return (
    <>
      <Banner />
      <StepUp />
      {/* <Jobs /> */}
      {/* <Courses /> */}
      <HelpBid />
      <TopSkills />
    </>
  );
}

export default LandingPage;
